import { Fade, Reveal } from 'react-awesome-reveal';
import fadeInDown from 'components/animations/fadeInDown';
// import Atropos from 'atropos/react';
import lang from 'constants/lang';
import translations from 'constants/artwork';
import classnames from 'classnames';
import ArtworkMap from './ArtworkMap.jsx';
import styles from './Artwork.module.scss';

const artworks = {
  'innovationpin': {
    id: 'innovationpin',
    name: 'INNOVATION\nPIN',
    author2: 'HKSTP',
    videos: {
      className: styles.pin,
      mp4: `${process.env.PUBLIC_URL}/videos/pin.mov`,
      webm: `${process.env.PUBLIC_URL}/videos/pin.webm`,
    },
  },
  ericbot404: {
    id: 'ericbot404',
    name: 'DANCE OF\nAMPHITRITE',
    author1: 'ERICBOT404',
    author2: 'GRST',
    techFocus: translations.cleanEnergy,
    videos: {
      className: styles.ericbot404,
      mp4: `${process.env.PUBLIC_URL}/videos/ericbot404.mp4`,
      webm: `${process.env.PUBLIC_URL}/videos/ericbot404.webm`,
    },
  },
  franknitty: {
    id: 'franknitty3000',
    name: 'MAN AND THE\nMACHINE',
    author1: 'FRANK NITTY',
    author2: 'SENSETIME',
    techFocus: translations.artificialIntelligence,
    videos: {
      className: styles.franknitty3000,
      mp4: `${process.env.PUBLIC_URL}/videos/franknitty.mp4`,
      webm: `${process.env.PUBLIC_URL}/videos/franknitty.webm`,
    },
  },
  'keithlam': {
    id: 'keithlam',
    name: 'MONONUCLEAR\nVITALITY',
    author1: 'KEITH LAM & DIMENSION PLUS',
    author2: 'MONOTX',
    techFocus: translations.bioTech,
    videos: {
      className: styles.keithlam,
      mp4: `${process.env.PUBLIC_URL}/videos/keithlam.mp4`,
      webm: `${process.env.PUBLIC_URL}/videos/keithlam.webm`,
    },
  },
  'stephlau': {
    id: 'stephlau',
    name: 'THE GARDEN\nFINDS ITS WAYS',
    author1: 'STEPH SHUE YAN LAU',
    author2: 'FARM66',
    techFocus: translations.agritech,
    videos: {
      className: styles.stephlau,
      mp4: `${process.env.PUBLIC_URL}/videos/stephlau.mp4`,
      webm: `${process.env.PUBLIC_URL}/videos/stephlau.webm`,
    },
  },
  'yarliallison': {
    id: 'yarliallison',
    name: 'RAINFORESTS\nOF THE SEA',
    author1: 'YARLI ALLISON',
    author2: 'ARCHIREEF',
    techFocus: translations.greenTech,
    videos: {
      className: styles.yarliallison,
      mp4: `${process.env.PUBLIC_URL}/videos/yarliallison.mp4`,
      webm: `${process.env.PUBLIC_URL}/videos/yarliallison.webm`,
    },
  },
  'argallery': {
    id: 'argallery',
  },
  'interview': {
    id: 'interview',
    name: '',
    author2: '',
  },
};

function Artwork({ artwork, artworkOrdering, setPage, currentArtworkMapItem, setArtworkMapItem }) {
  const currentIndex = artworkOrdering.indexOf(artwork);
  const nextIndex = currentIndex === artworkOrdering.length - 1 ? 0 : currentIndex + 1;
  const prevIndex = currentIndex === 0 ? artworkOrdering.length - 1 : currentIndex - 1;
  const nextIsInterview = currentIndex < artworkOrdering.length - 1 && artworkOrdering[currentIndex + 1] === 'interview';
  return (
    <div id="artwork" className={ classnames(styles.container, artwork === 'interview' && styles.containerInterview, artwork === 'argallery' && styles.containerARGallery) }>
      <div className={ styles.artwork }>
        {/* <Atropos
          eventsEl="#root"
          className={ styles.atropos }
          shadow={ false }
          highlight={ false }
          activeOffset={ 1 }
          rotateXMax={ 5 }
          rotateYMax={ 5 }
        > */}
        {
          artwork === 'argallery' && (
            <div className={ classnames(styles.atropos, styles.argallery) }>
              <ArtworkMap
                currentArtworkMapItem={ currentArtworkMapItem }
                setArtworkMapItem={ setArtworkMapItem }
              />
            </div>
          )
        }
        {
          artwork === 'interview' && (
            <div className={ classnames(styles.atropos, styles.interview) }>
              {
                [
                  'ericbot404',
                  'franknitty',
                  'keithlam',
                  'stephlau',
                  'yarliallison',
                ].map((artwork, index) => (
                  <div key={ `interview-video-${index}` } className={ classnames(styles.video, artworks[artwork].videos.className) }>
                    <video autoPlay loop muted playsInline>
                      <source src={ artworks[artwork].videos.mp4 } type='video/mp4; codecs="hvc1"' />
                      <source src={ artworks[artwork].videos.webm } type="video/webm" />
                    </video>
                  </div>
                ))
              }
            </div>
          )
        }
        {
          (artwork !== 'argallery' && artwork !== 'interview') && (
            <div className={ styles.atropos }>
              <div className={ classnames(styles.video, artworks[artwork].videos.className) }>
                <video autoPlay loop muted playsInline>
                  {
                    artworks[artwork].videos.mp4 && (
                      <source
                        src={ artworks[artwork].videos.mp4 }
                        type='video/mp4; codecs="hvc1"'
                      />
                    )
                  }
                  {
                    artworks[artwork].videos.webm && (
                      <source
                        src={ artworks[artwork].videos.webm }
                        type="video/webm"
                      />
                    )
                  }
                </video>
              </div>
            </div>
          )
        }
        {/* </Atropos> */}
      </div>

      {
        artwork !== 'argallery' && (
          <div className={ styles.metaParade } onClick={ () => setPage('/') }>
            <img src={ `${process.env.PUBLIC_URL}/images/meta-parade-white.svg` } alt="META-PARADE" />
          </div>
        )
      }

      {
        artwork !== 'argallery' && (
          <div className={ styles.details }>
            {
              artworks[artwork].author1 && (
                <>
                  <Fade fraction={ 0.25 } duration={ 1000 } triggerOnce>
                    <div className={ styles.author }>
                      { artworks[artwork].author1 }
                    </div>
                  </Fade>
                  <Fade fraction={ 0.25 } duration={ 1000 } triggerOnce>
                    <div className={ styles.plus }>
                      <img src={ `${process.env.PUBLIC_URL}/images/plus.svg` } alt="" />
                    </div>
                  </Fade>
                </>
              )
            }
            <Fade fraction={ 0.25 } duration={ 1000 } triggerOnce>
              <div className={ styles.desc }>
                <div className={ styles.hkstp }>
                  { artworks[artwork].author2 }
                </div>
                {
                  artworks[artwork].techFocus && (
                    <>
                      <div className={ classnames(styles.line, styles[artworks[artwork].id]) } />
                      <div className={ styles.techFocus }>
                        { artworks[artwork].techFocus }
                      </div>
                    </>
                  )
                }
              </div>
            </Fade>
            <Fade fraction={ 0.25 } duration={ 1000 } triggerOnce>
              <div className={ styles.artworkName }>{ artworks[artwork].name }</div>
            </Fade>
          </div>
        )
      }

      <div
        className={ classnames(styles.navigation, artwork === 'argallery' && styles.navigationARGallery, styles.left) }
        onClick={ () => currentIndex === 0 ? setPage('/') : setPage(`/artwork/${artworkOrdering[prevIndex]}`) }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/arrow-left.svg` } alt="<" />
      </div>
      {
        nextIsInterview && (
          <div className={ classnames(styles.viewInterviewText, styles[lang]) }>{ translations.viewInterview }</div>
        )
      }
      <div
        className={ classnames(styles.navigation, artwork === 'argallery' && styles.navigationARGallery, styles.right, (currentIndex === artworkOrdering.length - 1 || (currentIndex + 1 < artworkOrdering.length && artworkOrdering[currentIndex + 1] === 'argallery')) && styles.inactive) }
        onClick={ () => currentIndex !== artworkOrdering.length - 1 && setPage(`/artwork/${artworkOrdering[nextIndex]}`) }
      >
        <img src={ `${process.env.PUBLIC_URL}/images/arrow-right.svg` } alt=">" />
      </div>

      <div className={ styles.viewMore }>
        <Reveal keyframes={ fadeInDown } duration={ 1000 } triggerOnce>
          <span>{ translations.viewMore }</span><br />
        </Reveal>
        <Reveal keyframes={ fadeInDown } delay={ 500 } duration={ 1000 } triggerOnce>
          <img src={ `${process.env.PUBLIC_URL}/images/arrow-down.svg` } alt="" />
        </Reveal>
      </div>
    </div>
  );
}

export default Artwork;